import { Grid } from '@mui/material';
import { ApexOptions } from 'apexcharts';
import { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { IStageStatusTurnAroundTime, getSubmissionsTurnAroundTimeByStatus } from 'wisestep-api';
import { WsTypography } from 'wisestep-base';

import { getStageStatusSettings } from '../../../../utils/CandidateStageStatusHelper';
import DefaultStageStatusPipeline from '../../../../utils/DefaultStageStatusPipeline';
import { stageStatusPipelineType } from '../../../crmSettings/customizeStageStatus/helper';
import { ISeriesDataType } from '../../types';

const TurnAroundTimeByStageAnalytics = ({ jobId }: { jobId: string }) => {
  const [aggregatedData, setAggregatedData] = useState<IStageStatusTurnAroundTime[]>([]);
  const bucketData: ISeriesDataType[] = [];

  useEffect(() => {
    const fetchData = async () => {
      const response = await getSubmissionsTurnAroundTimeByStatus(jobId);
      const stageStatusResponse = await getStageStatusSettings();
      const stages: stageStatusPipelineType[] = JSON.parse(
        stageStatusResponse?.data?.stageStatusPipeline ?? DefaultStageStatusPipeline
      );

      const stageOrderMap = new Map(stages.map((stage) => [stage.stage, stage.stageOrder]));

      const sortedData = response.data.sort((item1, item2) => {
        const stageOrderA = stageOrderMap.get(item1.applicationStage) || 0;
        const stageOrderB = stageOrderMap.get(item2.applicationStage) || 0;

        return stageOrderA - stageOrderB;
      });

      setAggregatedData(sortedData);
    };

    fetchData();
  }, [jobId]);

  aggregatedData.forEach((item) => {
    bucketData.push({
      x: item.applicationStage ?? '',
      y: Number(item.avgStageDurationSeconds?.toFixed(2)),
    });
  });

  const options: ApexOptions = {
    chart: {
      height: 450,
      zoom: {
        enabled: true,
      },
    },
    xaxis: {
      title: {
        text: 'Candidate Stages',
      },
    },
    yaxis: {
      title: {
        text: 'Turn Around Time in days',
      },
    },
    dataLabels: {
      enabled: false,
    },
  };

  const series = [
    {
      data: bucketData,
    },
  ];

  return (
    <Grid container>
      <Grid item xs={12}>
        <WsTypography bold={true}>Average Turn Around time of stages</WsTypography>
      </Grid>
      <Grid item xs={12}>
        <ReactApexChart
          options={options}
          type="bar"
          series={series}
          title="Submissions Turn Around Time"
          height={400}
        />
      </Grid>
    </Grid>
  );
};

export default TurnAroundTimeByStageAnalytics;
